import React from 'react';
import {
  Marker,
  Popup,
  useMap
} from "react-leaflet";
import L from 'leaflet';
import { menu2icon } from './config';

/**
 * インフラツーリズムマップ: 施設情報マーカー
 * @param spot
 * @param latitude
 * @param longitude
 * @param menu
 * @param draggable
 * @param option
 * @returns {JSX.Element|null}
 * @constructor
 */
const Component = ({spot, latitude, longitude, menu, draggable=false, option}) => {

  const getIcon = (spot) => {

    // デフォルト
    let icon = menu2icon["vis_94"];
    
    return new L.Icon({
      iconUrl: icon,
      iconRetinaUrl: icon,
      iconSize: [35, 35],
      iconAnchor: [17, 23],
      popupAnchor: [0, -50]
    })

  };
  
  const map = useMap()
  const bounds = map.getBounds()
  const minlat = bounds._southWest.lat
  const maxlat = bounds._northEast.lat
  const minlng = bounds._southWest.lng
  const maxlng = bounds._northEast.lng

  const handleSpotData = (menu, spot) => {

    let ret = []

    const imageUrl = process.env.REACT_APP_DATA_94_BASE_URL+spot["写真"];

    ret.push(<dl className='dl-list is-modal-spot'><dt>施設名称</dt><dd>{spot["施設名称"]}</dd></dl>)
    ret.push(<dl className='dl-list is-modal-spot'><dt>緯度</dt><dd>{spot["緯度"]}</dd></dl>)
    ret.push(<dl className='dl-list is-modal-spot'><dt>経度</dt><dd>{spot["経度"]}</dd></dl>)
    ret.push(<dl className='dl-list is-modal-spot'><dt>分類</dt><dd>{spot["分類"]}</dd></dl>)
    ret.push(<dl className='dl-list is-modal-spot'><dt>施設概要</dt><dd>{spot["施設概要"]}</dd></dl>)
    ret.push(<dl className='dl-list is-modal-spot'><dt>HPリンク</dt><dd>{ (spot["HPリンク"] && spot["HPリンク"].includes('http')) && <a href={spot["HPリンク"]} target={"_blank"}>{spot["HPリンク"]}</a>}</dd></dl>)
    ret.push(<dl className='dl-list is-modal-spot'><dt>写真</dt><dd>{ spot["写真"] && <a href={imageUrl} target={"_blank"}><img src={imageUrl} alt={spot["施設名称"]} width="240"/></a>}</dd></dl>)

    return ret

  }

  if(latitude > minlat && latitude < maxlat && longitude > minlng && longitude < maxlng){

    return (
      <>
        <Marker
          position={[latitude, longitude]}
          icon={getIcon(spot)}
        >
          <Popup autoPan={false}  minHeight={300} maxHeight={400} minWidth={500} closeOnClick>
            {
              handleSpotData(menu, spot)
            }
          </Popup>
        </Marker>

      </>
    );
  }else{
    return null
  }
}

export default Component;
